export class SystemTableItemModel {
    id: string;
	name: string;
	Bucket: string;
}
